import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs';
import { ScrAuthenticationService, ScrAuthorizationService } from 'src/app/services';
import { ScrEnvironment } from 'src/environments/environment';
import { ShortCodesRole } from '../../../models/constants';

@Component({
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']

})
export class UnauthorizedComponent {

  public showWrongCredentialsSdError = false;
  public username?: string | null;

  constructor(route: ActivatedRoute, private env: ScrEnvironment, private auth: ScrAuthorizationService, private router: Router, private authenticationService: ScrAuthenticationService) {
    this.username = this.authenticationService.getScrUserName();
    route.data.pipe(first()).subscribe(data => {
      if (data?.compareCredentialsToApp) {
        // console.trace('compare env SD vs roles and maybe user signed in wrong');
        auth.getAuthorizedGroups().pipe(first()).subscribe(groups => {
          if (!groups.includes(ShortCodesRole.ServiceDesk) && env.servicedesk) {
            this.showWrongCredentialsSdError = true;
          }
        });
      }
    });
  }
  public back(): void {
    if (this.env.servicedesk) {
      this.auth.routeUserPostLogin(0).then(() => {
        // nothing
      });
    }
    else {
      history.back();
    }
  }

  public logout(): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.router.navigate(['sec/logout']).then(b => {
      // console.trace('logout nav was ' + b);
    });
  }
}
